<script>
import options from './GtmTracker.options'
export default options
</script>

<template></template>
